// React / other libraries
import React from 'react';
import shortid from 'shortid';
import { useNavigate } from 'react-router-dom';
import { DateTime } from 'luxon';

// MUI / Component
import useStyles from './styles';
import { Box, Skeleton, Typography } from '@mui/material';
import NavBar from '../../components/NavBar/NavBar';
import CustomizedIconButton from '../../components/Buttons/IconButton';

// Images
import { ReactComponent as ArrowIcon } from '../../assets/images/arrow_icon.svg';

// Hooks / Utils
import useResultList from '../../hooks/useResultList';

const ResultList = () => {
    const styles = useStyles();
    const navigate = useNavigate();
    const { loading, resultList, setResultList, sortOrder, handleSortByDate } = useResultList();

    let routePrefix = '/user';
    if (window.location.pathname.includes('/corp')) {
        routePrefix = '/corp';
    }

    return (
        <Box className={`${styles['.results-container']}`}>
            <NavBar />
            <Box className={`${styles['.ellipse-236']}`}></Box>
            <Box className={`${styles['.ellipse-237']}`}></Box>
            <Box className={`${styles['.frame-1944']}`}>
                <Box className={`${styles['.frame-1869']}`}>
                    <Box className={`${styles['.frame-1901']}`}>
                        {
                            // Delete request button
                            /* <svg
                            className={`${styles['.action-delete']}`}
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M5.82862 19.7999C5.82862 20.2773 5.99117 20.7351 6.28051 21.0727C6.56985 21.4103 6.96229 21.5999 7.37148 21.5999H16.6286C17.0378 21.5999 17.4302 21.4103 17.7196 21.0727C18.0089 20.7351 18.1715 20.2773 18.1715 19.7999V7.19991H5.82862V19.7999ZM14.5715 10.1999C14.5715 10.0408 14.6257 9.88816 14.7221 9.77564C14.8186 9.66312 14.9494 9.59991 15.0858 9.59991C15.2222 9.59991 15.353 9.66312 15.4494 9.77564C15.5459 9.88816 15.6 10.0408 15.6 10.1999V18.5999C15.6 18.759 15.5459 18.9116 15.4494 19.0242C15.353 19.1367 15.2222 19.1999 15.0858 19.1999C14.9494 19.1999 14.8186 19.1367 14.7221 19.0242C14.6257 18.9116 14.5715 18.759 14.5715 18.5999V10.1999ZM11.4858 10.1999C11.4858 10.0408 11.5399 9.88816 11.6364 9.77564C11.7328 9.66312 11.8637 9.59991 12 9.59991C12.1364 9.59991 12.2673 9.66312 12.3637 9.77564C12.4602 9.88816 12.5143 10.0408 12.5143 10.1999V18.5999C12.5143 18.759 12.4602 18.9116 12.3637 19.0242C12.2673 19.1367 12.1364 19.1999 12 19.1999C11.8637 19.1999 11.7328 19.1367 11.6364 19.0242C11.5399 18.9116 11.4858 18.759 11.4858 18.5999V10.1999ZM8.40005 10.1999C8.40005 10.0408 8.45423 9.88816 8.55068 9.77564C8.64713 9.66312 8.77794 9.59991 8.91433 9.59991C9.05073 9.59991 9.18154 9.66312 9.27799 9.77564C9.37444 9.88816 9.42862 10.0408 9.42862 10.1999V18.5999C9.42862 18.759 9.37444 18.9116 9.27799 19.0242C9.18154 19.1367 9.05073 19.1999 8.91433 19.1999C8.77794 19.1999 8.64713 19.1367 8.55068 19.0242C8.45423 18.9116 8.40005 18.759 8.40005 18.5999V10.1999ZM18.6858 3.59991H14.8286L14.5265 2.89866C14.4625 2.74874 14.3639 2.62263 14.2418 2.53452C14.1197 2.44641 13.979 2.39979 13.8354 2.39991H10.1615C10.0182 2.39927 9.87775 2.44571 9.75609 2.53392C9.63444 2.62213 9.53654 2.74854 9.47362 2.89866L9.17148 3.59991H5.31433C5.17794 3.59991 5.04713 3.66312 4.95068 3.77564C4.85423 3.88817 4.80005 4.04078 4.80005 4.19991V5.39991C4.80005 5.55904 4.85423 5.71165 4.95068 5.82417C5.04713 5.93669 5.17794 5.99991 5.31433 5.99991H18.6858C18.8222 5.99991 18.953 5.93669 19.0494 5.82417C19.1459 5.71165 19.2 5.55904 19.2 5.39991V4.19991C19.2 4.04078 19.1459 3.88817 19.0494 3.77564C18.953 3.66312 18.8222 3.59991 18.6858 3.59991V3.59991Z'
                                fill='#B6B6BF'
                            />
                        </svg> */
                        }
                        <Box className={`${styles['.frame-1945']}`}>
                            <Typography className={`${styles['.sort-by-last-saved']}`}>{'Sort By Last Saved'}</Typography>
                            <CustomizedIconButton onClick={handleSortByDate}>
                                {sortOrder === 'desc' ? (
                                    <ArrowIcon className={`${styles['.sort-desc']}`} />
                                ) : (
                                    <ArrowIcon className={`${styles['.sort-asc']}`} />
                                )}
                            </CustomizedIconButton>
                        </Box>
                    </Box>
                    <Box className={`${styles['.frame-1873']}`}>
                        {
                            // Render 5 Skeletons for loading
                            loading ? (
                                Array.from(Array(5).keys()).map((item, index) => {
                                    return (
                                        <Skeleton
                                            key={shortid.generate()}
                                            animation='pulse'
                                            variant='rounded'
                                            className={`${styles['.result-container-skeleton']}`}
                                        />
                                    );
                                })
                            ) : resultList.length > 0 ? (
                                resultList.map((item, index) => {
                                    return (
                                        <ResultContainer
                                            key={item.ext_id}
                                            id={item.ext_id}
                                            jdFileName={
                                                item?.job_description_file?.metadata?.url ??
                                                item?.job_description_file?.metadata?.file_original_name
                                            }
                                            cvCount={item?.training_files?.file_ext_id?.length}
                                            createDate={DateTime.fromISO(item.created_at).toFormat('yyyy/MM/dd hh:mm')}
                                            onClick={() => {
                                                navigate(`${routePrefix}/result/${item.ext_id}`);
                                            }}
                                        />
                                    );
                                })
                            ) : (
                                <Box className={`${styles['.no-result-container']}`}>
                                    <Typography variant='desktop_body' className={`${styles['.no-result']}`}>
                                        {'No Result Found'}
                                    </Typography>
                                </Box>
                            )
                        }
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default ResultList;

const ResultContainer = ({ id, jdFileName, cvCount, createDate, onClick }) => {
    const styles = useStyles();
    return (
        <Box className={`${styles['.result-container']}`} onClick={onClick}>
            <Box className={`${styles['.jd-file-name-50']}`}>
                <Typography variant='desktop_body' component='span'>
                    {jdFileName?.length > 80 ? `${jdFileName.substring(0, 80)}...` : jdFileName}
                </Typography>
                <Typography variant='desktop_body' component='span'>
                    {`(${cvCount})`}
                </Typography>
            </Box>
            <Box>
                <Typography variant='desktop_footnote' className={`${styles['.date']}`}>
                    {createDate}
                </Typography>
                <svg
                    className={`${styles['.arrows-right']}`}
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path d='M6 11.06L9.05333 8L6 4.94L6.94 4L10.94 8L6.94 12L6 11.06Z' fill='#FCFCFC' />
                </svg>
            </Box>
        </Box>
    );
};
